<template>
  <div class="select-container">
    <v-select
      :value="value"
      @input="processInput"
      :id="inputId"
      :options="options"
      :searchable="false"
      :clearable="false"
      :components="{OpenIndicator}"
    />
  </div>
</template>

<script>
  export default {
    name: 'SelectInput',
    data () {
      return {
        placement: 'down',
        OpenIndicator: {
          render: createElement => createElement('div', {class: {'triangle-opener': true}})
        }
      }
    },
    props: {
      inputId: {
        type: String,
        required: true
      },
      value: {
      },
      options: {
        type: Array,
        required: true
      }
    },
    methods: {
      processInput (val) {
        this.$emit('input', val)
      }
    },
    mounted () {
    },
    computed: {
      x () {
        return this.options.map((x) => {
          return {
            label: x.label,
            value: x.code
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "src/assets/styles/core_variables";
  @import "src/assets/styles/modules/vselect/vue-select.scss";

  .select-container {
    div.triangle-opener {
      width: 100%;
      height: 100%;
      background-size: 0.22em 0.13em;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url($static-path + '/images/arrow-down.svg');
    }

    .vs__selected {
      font-size: 0.16em;
      font-weight: 500;
      color: #202020;
    }

    .vs__search {
      margin: 0px;
      border-width: 0px;
      padding: 0px;
      height: 100%;
    }
  }

  html.smartphone {
    .select-container {
      div.triangle-opener {
        background-size: 0.18em 0.106em;
      }

      .vs__selected {
        font-size: 0.13em;
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/SelectInput.vue